import tmdb from './client';

const PopularMovie = (page, config = {}) =>
  tmdb.get('/movie/popular', {
    ...config,
    params: { language: 'en-US', page, ...(config.params || {}) },
  });

export default PopularMovie;
